export const createShareText = (platform: string, headline?: string | null): string => {
	// Twitter shares the headline of the article in tweet text, so we add this one here.
	if (platform && headline) {
		return headline;
	}

	return '';
};
